module.exports = __webpack_public_path__ + "static/media/img_faceassessmenton_nose_lip_chin.949f889f.jpg";